// @flow
import React from "react";

import { strings, images, PLACE_SUGGESTION_DROPOFF_RADIUS_METERS } from '../../../../../config';
import {DestAddressLabel} from "../../../../Address/AddressesStyle";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import AutocompleteSearch from "./AutocompleteSearch";
import DestAutocompleteOperations from "../../../../../Store/Ducks/DestAutocomplete/operations";
import DestAutocompleteSelectors from "../../../../../Store/Ducks/DestAutocomplete/selectors";
import CurrentRequestOperations from "../../../../../Store/Ducks/CurrentRequest/operations";

const DestAddressSearch = props => {
    return (
        <AutocompleteSearch
            {...props}
            name="DestAddressSearchWindow"
            pinImageMain={{src: images.request_dest_pin, alt: "dest pin"}}
            addressTitleLabel={<DestAddressLabel>{strings.dest_address_label}</DestAddressLabel>}
            addressField={<AutocompleteSearch
                setInputAddress={props.setInputAddress}
                getAddressValue={props.getAddressValue}
                selectSuggestedOption={props.selectSuggestedOption}
                searchPlaceholder={strings.address_search_dest_placeholder}
            />}
            pinImageSecondary={{src: images.search_dest, alt: "search dest"}}
            selectSuggestedOption={props.selectSuggestedOption}
            radiusInMeters={PLACE_SUGGESTION_DROPOFF_RADIUS_METERS}
        />
    );
};
const mapStateToProps = state => {
    return {
        getAddressValue: DestAutocompleteSelectors.destAutocompleteAddress(state),
    };
};

const mapActionsToProps = (dispatch, props) => {
    return bindActionCreators(
        {
            setInputAddress: DestAutocompleteOperations.setDestInputAddress,
            selectSuggestedOption: CurrentRequestOperations.selectDestSuggestion,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapActionsToProps)(DestAddressSearch);



// WEBPACK FOOTER //
// ./src/Components/Screen/RideRequest/FreeSelection/AddressSearch/DestAddressSearch.js